module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQtJREFUeNpiNAqYWsDAwNDPQB9wAYgdmYBEPQP9gAEIgywVYKAzYGIYAMBCDUOkxHgZIn30GdQVRTDk0mo3UN9SXycNhuIkawZebnb6+BTkw4ZcJ/rGaVq4Kf3j1FhHGkNs874bDGevPmN49uoz7YIXGdy6/4ahYfI++maZz19/DZN8CgpOSTE+nPK83Gwo8fz5609wkFNkKShP4kuxasDCYVazP5x/9sozrIUDTYP32atP9I/T568/099SXHmVpDgFZfwzwHiCAeT4g+XTnnlHUfgUWwpyOb6SBpRPz155Ojjz6ailo5YObUs/DISlC+ho3wNQ14Ll3IbsQmB/ZiE9WvpAuw6AaIAAAwCCzlQkWusnEgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/english2/f1.png
// module id = J8/+
// module chunks = 1